module.exports = __webpack_public_path__ + "static/product-scaling-banner-image-8f78f65623c7f76d5256b2c70391d765.png";